/**
 * Uppercases the first character of a string, leaving the rest untouched.
 *
 * Used for French date and period labels, which date-fns and the translation
 * files produce in lower case ("samedi 8 août", "après-midi") but which read as
 * sentence starts in the UI. CSS is not an option here: `capitalize` would also
 * uppercase the month name, and `first-letter:` has no effect on the inline
 * elements these labels live in.
 *
 * @param value - the text to capitalise
 * @returns the text with its first character uppercased
 */
export const capitalizeFirst = (value: string): string =>
  value.charAt(0).toUpperCase() + value.slice(1);
